import React from "react";
import styles from "./styles.module.scss";
import { DisqualifyingSlideType } from "../../../types/DisqualifyingSlide";
import SlideNavigation, { OnNavigationType } from "../_basic/SlideNavigation";

interface DisqualifyingSlideProps {
  data: DisqualifyingSlideType;
  onNavigation: OnNavigationType;
  submitModal: any;
}

const DisqualifyingSlide: React.FC<DisqualifyingSlideProps> = ({
  data,
  submitModal,
  onNavigation,
}) => {
  return (
    <div className={styles.mainContainer}>
      <div className={styles.content}>
        {data?.descriptionHeader && (
          <p dangerouslySetInnerHTML={{ __html: data.descriptionHeader }} />
        )}
      </div>
      <div className={styles.navigationButton}>
        <SlideNavigation
          onNavigation={() => {
            if (submitModal) onNavigation(-2);
            else onNavigation(-1);
          }}
          backText={data?.navigation?.type === "backwardOnly" ? "Avanti" : ""}
        />
      </div>
    </div>
  );
};

export default DisqualifyingSlide;
